import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root' })
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], fileName?: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data1: worksheet },
      SheetNames: ['data1'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName?: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    const name = fileName
      ? `${fileName}${EXCEL_EXTENSION}`
      : `${new Date().getTime()}${EXCEL_EXTENSION}`;

    FileSaver.saveAs(data, name);
  }
}
